import { startCase } from 'lodash';

const LABELS: Record<string, string> = {
  uuid: 'User ID',
  oldUuid: 'Old User ID',
};
export const getLabel = (key: string) => {
  if (key in LABELS) return LABELS[key];
  return startCase(key);
};

export interface ProcessingProfile {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  countryCode: string;
  externalReference: string;
  oldExternalReference: string | null;
  status: string;
}
export interface ProcessingUser {
  userId: string;
  email: string;
  oldUserId?: string;
  profile?: ProcessingProfile;
  externalReference: string;
}
